import React from 'react';
import { Inbox } from 'lucide-react';

function EmptyState({ icon: Icon = Inbox, title = 'Nothing here yet', message, action }) {
  return (
    <div style={styles.wrap}>
      <div style={styles.iconWrap}>
        <Icon size={24} />
      </div>
      <p style={styles.title}>{title}</p>
      {message && <p style={styles.message}>{message}</p>}
      {action && <div style={styles.action}>{action}</div>}
    </div>
  );
}

const styles = {
  wrap: {
    textAlign: 'center',
    padding: '48px 24px',
  },
  iconWrap: {
    width: '48px',
    height: '48px',
    margin: '0 auto 16px',
    borderRadius: '50%',
    backgroundColor: 'var(--color-bg-alt)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--color-muted)',
  },
  title: {
    fontSize: '15px',
    fontWeight: 700,
    color: 'var(--color-ink)',
    margin: '0 0 6px',
  },
  message: {
    fontSize: '13px',
    color: 'var(--color-ink-soft)',
    margin: 0,
  },
  action: {
    marginTop: '16px',
  },
};

export default EmptyState;
